import React from 'react';

interface TurbopufferIconProps {
  height?: number;
  className?: string;
}

export const TurbopufferLogo: React.FC<TurbopufferIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 257 257"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="m.5.5h256v256h-256z" fill="#0f172a" />
      <path
        clipRule="evenodd"
        d="m82 115.75h-10.25v5.25h10.25zm-5.25 10.5h-9v9.75h9zm10.25 6.5h10.5v11.25h10.5v5h5.25v9.75h9.5v10h63.75v15.25h-11.75v5h-46.75v-5h-16v-10h-9.75v-9.75h-5v-5h-5.25v-15.25h-5z"
        fill="#9cdae0"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m107.25 101.75h113.25v46.75 1.25 4h-5.5v5.5 4.75h-5.25v4.75h-5.25v5.5h-5.25v5h-42v-5h-14v-5.5h-15.25v-4.75h-5.5v-4.75h-15.25v-9.5-2.25z"
        fill="#b7e2f4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m129 62.5h46v4.25h6.25v10h12.75v5h10.25v9.75h5.5v23.5h-5.5-7.25-3-2.5-10.25-6.25-6.5-5-15.25-13.25v14h-38v-33.25h5.25v-14h15.25v-5h5v-5h6.5zm-57.25 34h5v8.75h5.25v7h-5.25v3.5h-5z"
        fill="#d6bfa2"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m166.5 67.25h9v4.75h-9zm0 9.75h-13.75v-5h13.75zm0 0h4.75v4.75h9.75v-5h5.25v5h-5v4.75h14v5.5h-4.25v9.75h-4.75v-9.75h-10.25v-5.5h-9.5v-4.5-.25zm38.25 14.75h-9v9.75h9zm-28.75 14.5h-7.25v8.75.25 8.75h-5.75v4.5h-15-4.75v-4.5h-5v-9h-5v9h-5.25v4.25h-5.5v5.25h5.5v10h5.25v-4.75h4.75v10h5.25v5h4.75 4.75v-5.25h-4.75v-5h9.5v5.25h5.25v5h3.75v5h9.75v-5h5v5h19v-5h9.75 15v-35.5h-22v-12h-15.75v8.75h-11.25zm24.25 17.25h-13v.5 4.5h-4.75v10l3.25 4.625h2.625v5.375h11.875zm-96-10h3.25v4.75h9.5v1.5h-12.75v-1.5zm104.25-12h7v9.5h-7zm-75.25-24.5h5v4.75h-5zm33.25 9.75h-9.25v4.75h-4.5v5h10v4.75h13.25v-4.75h-4.75v-5h-4.75zm-23.25 0h9.25v5h-9.25zm19.5 14.75h-9.75v9.5h9.75z"
        fill="#fffff3"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m122.5 86.75h5.5v4.75h-5.5zm-50.75 4.75h-8.5v29.5h8.5zm45.25 26.75h-12.75v-4.75h-1.75v4.75h-5v10h4.75v10h14.75v-10zm21.25-26.5h-5.25v4.75h5.25zm-20.5 51.75h10.25v5.25h-10.25zm39.75 0h-9.5v5h4.75v5h-4.75v5.25h9.25v5h9.25v-5-5.25h-9v-5zm-19.5 5.25h5.25v5h-5.25zm28.75 15.25h9.25v5h-9.25zm24.25 0h-4.75v-5.25h-10.25v5.25h5.25v4.75h9.75zm0 0h14v-5.25h5v-5h-9.75v5h-9.25zm29.25-20.25h-4.75v4.75h4.75zm-28.75-25h8.75v4.75h-13l.5-1.125zm33.5 14.75h-4.75v4.75h4.75z"
        fill="#ffe295"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m71.75 98.5h-4.25v3 4.75h9v-4.75h-4.75z"
        fill="#fffff3"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m117.25 86.5h-5.25l-4.5 4.5v.75h9.75zm-30 19.75h4.75v8.25h-4.75zm-5.25 20h5v5h-5zm25.25 17.25h-5.25v5h5.25zm102.75 15.25h-5v5.25h5zm-10.75 10.25h-5v5.25h5zm-12.75 5h7.25v5h-7.25zm-53.5 10h-5v5h5zm-13.5-20h8.5v5h-8.5zm-42.75-33h-5v5h5z"
        fill="#213260"
        fillRule="evenodd"
      />
      <g fill="#fff3cc">
        <path d="m16.5 92h4v4.25h-4z" />
        <path d="m25.25 106.5h3.5v4.25h-3.5z" />
        <path d="m33.75 106.5h3v4.25h-3z" />
        <path d="m37.75 169.5h8.5v4.25h-8.5z" />
        <path d="m51 169.5h35.5v4.25h-35.5z" />
        <path d="m68.5 160h3.75v4.25h-3.75z" />
        <path d="m82 159.5h10v4.75h-10z" />
        <path d="m17 169.5h7.75v4.25h-7.75z" />
        <path d="m29.5 155.25h57.5v4.25h-57.5z" />
        <path d="m38.25 106.5h25v4.25h-25z" />
        <path d="m17 122.5h24.75v4.25h-24.75z" />
        <path d="m37.75 131.75h25.5v4.25h-25.5z" />
        <path d="m33.75 145.75h48.25v4.25h-48.25z" />
        <path d="m21 145.75h8v4.25h-8z" />
        <path d="m25.25 92h4v4.25h-4z" />
        <path d="m33.5 92h4v4.25h-4z" />
        <path d="m17 106.5h3.5v4.25h-3.5z" />
        <path d="m42.25 92h21v4.25h-21z" />
        <path d="m79.75 91.5h12.25v4.75h-12.25z" />
        <path d="m21 131.75h3.75v4.25h-3.75z" />
        <path d="m46.5 122.5h3.75v4.25h-3.75z" />
        <path d="m17 155.25h3.5v4.25h-3.5z" />
      </g>
      <path
        clipRule="evenodd"
        d="m193.25 123.5h7v4.75h-7zm0 9.75v-5h-6v5zm0 0v5h7v-5z"
        fill="#fb915f"
        fillRule="evenodd"
      />
      <path d="m187.25 133.25h6v5h-6z" fill="#9c4987" />
    </svg>
  );
};
